<div class="col-md-10 offset-md-1"
     style="padding-top: 30px">
    <div *ngIf="this.coordName">
        <h6>All authorities for {{this.coordName}}</h6>
    </div>
    <div class="input-group">
        <input class="form-control"
               placeholder="Type authority name"
               [(ngModel)]="searchTerms">
        <div class="pull-right">&nbsp;
            <button class="btn btn-primary btn-ncb-wide"
                    [routerLink]="[0,'edit']">New Authority</button>
        </div>
    </div>
    <p>
    <p>
    <p>
    <div class="tableFixHead">
        <table>
            <thead>
                <th *ngFor="let col of cols"><a (click)="lh.setOrder(col.name);">
                        <span><i *ngIf="lh.listOrder==col.name"
                               [className]="lh.orderDesc?'fa fa-sort-alpha-desc':'fa fa-sort-alpha-asc'"></i></span>
                        {{col.label}}</a>&nbsp;</th>
            </thead>
            <tbody *ngFor="let authority of authorities">
                <tr *ngIf="filterResults(authority)">
                    <td width=80%><a [ngStyle]="{'color': authority.licnum==authority.inactive?'gray':'#0068ec'}"
                           [routerLink]="['/authority',authority.id,'edit']"
                           [innerHTML]="authority.name | highlight: this.searchTerms"></a></td>
                    <td><a [routerLink]="['/license','auth',authority.id]">{{authority.licnum}}</a></td>
                    <td>{{authority.updatedDate | date: 'MM/dd/yy h:mm a'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>